import React from 'react';

import * as S from './Feedback.styles';

import PaymentFooter from '@/components/Footer';

interface IFeedbackProps {
  children: React.ReactNode;
}

interface IFeedbackImageProps {
  src: string;
  alt: string;
}

interface IFeedbackButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FeedbackContainer: React.FC<IFeedbackProps> = ({ children }) => {
  return (
    <S.Wrapper>
      <span /> {/* used in grid layout */}
      <S.Container>
        <S.Content>{children}</S.Content>
      </S.Container>
      <PaymentFooter />
    </S.Wrapper>
  );
};

export const FeedbackImage: React.FC<IFeedbackImageProps> = ({ src, alt }) => {
  return <S.Img src={src} alt={alt} />;
};

export const FeedbackTitle: React.FC<IFeedbackProps> = ({ children }) => {
  return <S.Title>{children}</S.Title>;
};

export const FeedbackSubtitle: React.FC<IFeedbackProps> = ({ children }) => {
  return <S.Subtitle>{children}</S.Subtitle>;
};

export const FeedbackRetryText: React.FC<IFeedbackProps> = ({ children }) => {
  return <S.RetryText>{children}</S.RetryText>;
};

export const FeedbackButton: React.FC<IFeedbackButtonProps> = ({
  className,
  children,
  onClick,
}) => {
  return (
    <S.CustomButton className={className} onClick={onClick}>
      {children}
    </S.CustomButton>
  );
};
